import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import axios from "axios";
console.log(process.env.NODE_ENV);
let baseURL;
if (location.hostname === "v5.uniauc.com") {
  global.baseAPIURL = "https://kr.api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else if (location.hostname === "admin.uniauc.com") {
  global.baseAPIURL = "https://kr.api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else if (location.hostname === "localhost") {
  // global.baseAPIURL = "https://kr.api.uniauc.com";
  global.baseAPIURL = "http://localhost:4003";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else {
  global.baseAPIURL = "https://kr.api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
}
// if (location.hostname === "resell.glocing.com") {
//   baseURL = "https://api.resell.glocing.com";
// } else if (location.hostname.includes("192.168.")||location.hostname === "localhost") {
//   baseURL = "http://"+location.hostname+":4005";
// } else if (location.hostname === "kr.resell.glocing.com") {
//   baseURL = "http://kr.api.resell.glocing.com";
// } else if (location.hostname === "glocing.com") {
//   // baseURL = "http://localhost:4005";
//   baseURL = "http://glocing.com:4005";
// }
// axios.defaults.baseURL=baseURL
axios.defaults.withCredentials = true;
const store = new Vuex.Store({
  getters: {
    isAuthenticated: (state) => !!state.user.nick,
    stateUser: (state) => state.user,
  },
  state: {
    user: { isAuthenticated: null },
    copiedCategory: {},
    modalCategory: {},
    lang: "en",
    currency: "USD",
    balance: 0,
  },
  mutations: {
    setCopiedCategory(state, category) {
      state.copiedCategory = category;
    },
    setModalCategory(state, category) {
      state.modalCategory = category;
    },
    setBalance(state, balance) {
      state.balance = balance;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
    setCart(state, { cartItem, type }) {
      // state.cart[type] = {...state.cart[type], ...cartItem}
    },
    SET_USER(state, data) {
      state.user = { ...state.user, ...data };
      if (state.user.nick) {
        state.user.isAuthenticated = true;
      } else {
        state.user.isAuthenticated = false;
      }
    },
    DELETE_USER(state) {
      state.user = {
        isAuthenticated: false,
      };
    },
    warn(state, data) {
      let msg, sec;
      if (typeof data === "object") {
        ({ msg, sec = 5 } = data);
      } else {
        msg = data;
        sec = 5;
      }
      state.alert_msg = msg;
      state.dismissCountDown = sec;
    },
    countDown(state, dismissCountDown) {
      state.dismissCountDown = dismissCountDown;
    },
  },
  actions: {
    // nuxtServerInit is called by Nuxt.js before server-rendering every page
    async getSession({ commit }) {
      // try {

      const { data } = await axios.get("/get-session");
      const { id, marketId, shopId, nick, email, level, isAdmin } = data;
      commit("SET_USER", {
        id,
        marketId,
        shopId,
        nick,
        email,
        level,
        isAdmin,
      });

      return data;
      // } catch (error) {
      //   console.log(error);
      //   return { error: "Server error" };
      // }
    },
    async login({ commit }, { username, password }) {
      try {
        const { data } = await axios.post("/authorize", {
          username,
          password,
        });
        if (data.error) return { error: data.error };
        let { id, nick, email, shopId, marketId, level, useOtp } = data;
        commit("SET_USER", {
          id,
          nick,
          email,
          shopId,
          marketId,
          level,
          useOtp,
        });

        return { error: "" };
      } catch (error) {
        if (error.response && error.response.status === 401) {
          return { error: "Bad credentials" };
        } else {
          return { error: "Server error" };
        }
      }
    },
    async logout({ commit }) {
      await axios.post("/logout");
      commit("DELETE_USER");
    },
  },
});

export default store;
